import { BlockATemplate } from '../types';
import { BLOCK_A_TEMPLATES as MUSIC_BLOCK_A } from '../templates/blockA';

// Minimal AI curriculum Block A templates for wiring tests
const AI_BLOCK_A: Record<string, BlockATemplate> = {
  '1': {
    levelId: '1',
    questions: [
      {
        id: 'ai-what-learned-1',
        type: 'multiple_choice',
        prompt: 'Today in AI class I... ',
        options: [
          '🤖 Learned what AI means',
          '🧠 Found patterns',
          '🌳 Picked an AI mascot',
          '💬 Talked about decisions'
        ],
        correctIndex: 0,
      },
      {
        id: 'ai-enjoyment-1',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '2': {
    levelId: '2',
    questions: [
      {
        id: 'ai-what-learned-2',
        type: 'multiple_choice',
        prompt: 'Today in AI class I... ',
        options: [
          '🧩 Spotted patterns',
          '🍎 Grouped similar items',
          '🔍 Explained why items match',
          '🎯 Practiced quick sorting'
        ],
        correctIndex: 1,
      },
      {
        id: 'ai-enjoyment-2',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '3': {
    levelId: '3',
    questions: [
      {
        id: 'ai-what-learned-3',
        type: 'multiple_choice',
        prompt: 'Today in AI class I... ',
        options: [
          '✅ Answered yes/no questions',
          '🌲 Built a small decision tree',
          '🧠 Described simple rules',
          '🎮 Tested decisions in a game'
        ],
        correctIndex: 1,
      },
      {
        id: 'ai-enjoyment-3',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
};

// New curriculum: ai-fall-2025 Block A templates (levels 1-5)
const AI_FALL_2025_BLOCK_A: Record<string, BlockATemplate> = {
  '1': {
    levelId: '1',
    questions: [
      {
        id: 'ai-fall-2025-clarity-1',
        type: 'emoji_rating',
        prompt: 'How clear was your prompt today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-match-1',
        type: 'emoji_rating',
        prompt: 'How well did the image match your words?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-enjoyment-1',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '2': {
    levelId: '2',
    questions: [
      {
        id: 'ai-fall-2025-story-parts-2',
        type: 'emoji_rating',
        prompt: 'Did your story include setting, characters, and events?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-revision-2',
        type: 'emoji_rating',
        prompt: 'How much did you revise after feedback?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-enjoyment-2',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '3': {
    levelId: '3',
    questions: [
      {
        id: 'ai-fall-2025-dialogue-3',
        type: 'emoji_rating',
        prompt: 'How clear was your scene’s dialogue?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-voices-3',
        type: 'emoji_rating',
        prompt: 'How well did the voices match your intent?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-enjoyment-3',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '4': {
    levelId: '4',
    questions: [
      {
        id: 'ai-fall-2025-video-match-4',
        type: 'emoji_rating',
        prompt: 'How well did your video match your prompt?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-pacing-4',
        type: 'emoji_rating',
        prompt: 'How clearly did you control mood and pacing?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-enjoyment-4',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '5': {
    levelId: '5',
    questions: [
      {
        id: 'ai-fall-2025-confidence-5',
        type: 'emoji_rating',
        prompt: 'How confident are you presenting your portfolio?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-director-5',
        type: 'emoji_rating',
        prompt: 'Did AI follow your direction (not do the thinking)?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'ai-fall-2025-enjoyment-5',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
};

// New curriculum: ai-2026-create-worlds Block A templates (levels 1-12)
const AI_CREATE_WORLDS_2026_BLOCK_A: Record<string, BlockATemplate> = {
  '1': {
    levelId: '1',
    questions: [
      {
        id: 'cwai-clarity-1',
        type: 'emoji_rating',
        prompt: 'How clear were your complete-sentence prompts today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-control-1',
        type: 'emoji_rating',
        prompt: 'Did the character image match your words?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-1',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '2': {
    levelId: '2',
    questions: [
      {
        id: 'cwai-detail-2',
        type: 'emoji_rating',
        prompt: 'How much did adding details improve your world image?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-collab-2',
        type: 'emoji_rating',
        prompt: 'How well did you collaborate with your partner today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-2',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '3': {
    levelId: '3',
    questions: [
      {
        id: 'cwai-story-3',
        type: 'multiple_choice',
        prompt: 'My story had…',
        options: [
          'A beginning (introduction)',
          'A middle (conflict)',
          'An end (resolution)',
          'All three parts',
        ],
        correctIndex: 3,
      },
      {
        id: 'cwai-context-3',
        type: 'emoji_rating',
        prompt: 'How helpful was adding context (character + world) to your prompt?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-3',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '4': {
    levelId: '4',
    questions: [
      {
        id: 'cwai-style-4',
        type: 'emoji_rating',
        prompt: 'How well did you choose style + mood for your video?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-video-match-4',
        type: 'emoji_rating',
        prompt: 'How well did the video match your prompt?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-4',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '5': {
    levelId: '5',
    questions: [
      {
        id: 'cwai-3d-understand-5',
        type: 'emoji_rating',
        prompt: 'How well do you understand what a 3D model is?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-3d-explain-5',
        type: 'emoji_rating',
        prompt: 'How well could you explain “texture” to a friend?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-5',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '6': {
    levelId: '6',
    questions: [
      {
        id: 'cwai-music-mood-6',
        type: 'emoji_rating',
        prompt: 'How well did your song match the mood of your world?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-lyrics-6',
        type: 'emoji_rating',
        prompt: 'How proud are you of your lyrics?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-6',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '7': {
    levelId: '7',
    questions: [
      {
        id: 'cwai-mechanics-7',
        type: 'emoji_rating',
        prompt: 'How clear was your game’s goal and win/lose rules?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-playable-7',
        type: 'emoji_rating',
        prompt: 'How playable was your game today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-7',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '8': {
    levelId: '8',
    questions: [
      {
        id: 'cwai-boss-8',
        type: 'emoji_rating',
        prompt: 'How creative was your boss design today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-rules-8',
        type: 'emoji_rating',
        prompt: 'How clear were your boss rules (patterns/weaknesses)?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-8',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '9': {
    levelId: '9',
    questions: [
      {
        id: 'cwai-sfx-9',
        type: 'emoji_rating',
        prompt: 'How well did your sound effects fit your game?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-organize-9',
        type: 'emoji_rating',
        prompt: 'How well did you organize and name your files?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-9',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '10': {
    levelId: '10',
    questions: [
      {
        id: 'cwai-feedback-10',
        type: 'emoji_rating',
        prompt: 'How kind and specific was your feedback today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-iterate-10',
        type: 'emoji_rating',
        prompt: 'How ready are you to improve your game next time?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-10',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '11': {
    levelId: '11',
    questions: [
      {
        id: 'cwai-accuracy-11',
        type: 'emoji_rating',
        prompt: 'How accurate were your prompts today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-limits-11',
        type: 'emoji_rating',
        prompt: 'How well did you notice the limits of AI?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-11',
        type: 'emoji_rating',
        prompt: 'How much did you like class today?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
  '12': {
    levelId: '12',
    questions: [
      {
        id: 'cwai-proud-12',
        type: 'emoji_rating',
        prompt: 'How proud are you of your final portfolio?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-director-12',
        type: 'emoji_rating',
        prompt: 'Did you stay the director (AI helped, but you decided)?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
      {
        id: 'cwai-enjoy-12',
        type: 'emoji_rating',
        prompt: 'How much did you like the program overall?',
        emojiRange: { min: 1, max: 5, emojis: ['😡','😕','😐','🙂','😄'] },
      },
    ],
  },
};

const REGISTRY: Record<string, Record<string, BlockATemplate>> = {
  music: MUSIC_BLOCK_A,
  ai: AI_BLOCK_A,
  'ai-fall-2025': AI_FALL_2025_BLOCK_A,
  'ai-2026-create-worlds': AI_CREATE_WORLDS_2026_BLOCK_A,
};

export function getBlockATemplates(curriculumId?: string | null): Record<string, BlockATemplate> {
  const key = (curriculumId || 'music').trim().toLowerCase();
  return REGISTRY[key] || MUSIC_BLOCK_A;
}

export function getBlockATemplateByCurriculum(levelId: string, curriculumId?: string | null): BlockATemplate | null {
  const templates = getBlockATemplates(curriculumId);
  return templates[levelId] || null;
}
